import { createRouter, createWebHistory } from "vue-router";
import AdminLayout from "../views/layouts/AdminLayout.vue";
// import HomeView from '../views/HomeView.vue'
import config from "@/configs/config";

function lazyLoad(view) {
  return () => import(`@/views/pages/${view}.vue`);
}
const routes = [
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: lazyLoad("NotFound"),
    redirect: "/admin",
    meta: {
      // here
      module: "NOTFOUND",
    },
  },
  {
    path: "/ondev",
    component: AdminLayout,
    children: [
      {
        path: "",
        name: "OnDevelopmentDirect",
        component: lazyLoad("OnDev"),
      },
    ],
  },
  {
    path: "/",
    name: "login",
    component: lazyLoad(
      `User/${
        config.owner[
          config.owner.findIndex((owner) => owner.id === config.activeOwner)
        ].loginFile
      }`
    ),
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: lazyLoad("AboutView"),
  },
  {
    path: "/admin/mydashboardtms",
    name: "myDashboardTms",
    component: lazyLoad("MyDashboard/MyDashboardIndex"),
  },
  {
    path: "/privacy_policy",
    name: "PrivacyPolicy",
    component: lazyLoad("Setting/PrivacyPolicyPage"),
  },
    {
    path: "/privacy_policy_forsis",
    name: "PrivacyPolicyForsis",
    component: lazyLoad("Setting/PrivacyPolicyForsisPage"),
  },
  {
    path: "/track/:uuid/:type",
    name: "TrackTrace",
    component: lazyLoad("Report/TrackTrace/TrackTracePage"),
  },
  {
    path: "/track_order/:uuid/:type",
    name: "TrackOrder",
    component: lazyLoad("Report/TrackTrace/TrackOrderPage"),
  },
  {
    path: "/admin",
    name: "admin-layout",
    component: AdminLayout,
    redirect: "/admin/commandcenter",
    children: [
      {
        path: "partner",
        name: "Partner",
        component: lazyLoad("Master/Partner/MasterPartnerPage"),
      },
      {
        path: "partner/add",
        name: "Add Partner",
        component: lazyLoad("Master/Partner/AddPartnerPage"),
      },
      {
        path: "partner/edit/:partner_id",
        name: "Edit Partner",
        component: lazyLoad("Master/Partner/EditPartnerPage"),
      },
      {
        path: "user/setting",
        name: "User Setting",
        component: lazyLoad("User/UserSettingPage"),
      },
      {
        path: "pricing",
        name: "Pricing",
        component: lazyLoad("Master/Pricing/MasterPricingPage"),
      },
      {
        path: "pricing/add",
        name: "Add Pricing",
        component: lazyLoad("Master/Pricing/AddPricingPage"),
      },
      {
        path: "pricing/edit/:transaction_id",
        name: "Edit Pricing",
        component: lazyLoad("Master/Pricing/EditPricingPage"),
      },
      {
        path: "customer",
        name: "Customer",
        component: lazyLoad("Master/Customer/MasterCustomerPage"),
      },
      {
        path: "customer/add",
        name: "Add Customer",
        component: lazyLoad("Master/Customer/AddCustomerPage"),
      },
      {
        path: "customer/edit/:customer_id",
        name: "Edit Customer",
        component: lazyLoad("Master/Customer/EditCustomerPage"),
      },
      {
        path: "fleet",
        name: "Fleet",
        component: lazyLoad("Master/Fleet/MasterFleetPage"),
      },
      {
        path: "fleet/add",
        name: "Add Fleet General",
        component: lazyLoad("Master/Fleet/AddFleetPage"),
      },
      {
        path: "fleet/add/:partner_id",
        name: "Add Fleet",
        component: lazyLoad("Master/Fleet/AddFleetPage2"),
      },
      {
        path: "fleet/edit/:fleet_id",
        name: "Edit Fleet General",
        component: lazyLoad("Master/Fleet/EditFleetPage"),
      },
      {
        path: "fleet/edit2/:fleet_id",
        name: "Edit Fleet",
        component: lazyLoad("Master/Fleet/EditFleetPage2"),
      },
      {
        path: "freight",
        name: "Freight",
        component: lazyLoad("Master/Freight/MasterFreightPage"),
      },
      {
        path: "freight/add",
        name: "Add Freight",
        component: lazyLoad("Master/Freight/AddFreightPage"),
      },
      {
        path: "freight/edit/:freight_id",
        name: "Edit Freight",
        component: lazyLoad("Master/Freight/EditFreightPage"),
      },
      {
        path: "order",
        name: "Order",
        component: lazyLoad("Order/ListOrderPage"),
      },
      {
        path: "order/add",
        name: "Add Order",
        component: lazyLoad("Order/AddOrderPage"),
      },
      {
        path: "order/edit/:order_id",
        name: "Edit Order",
        component: lazyLoad("Order/EditOrderPage"),
      },
      {
        path: "truckposition",
        name: "Truck Position",
        component: lazyLoad("Report/TruckPosition/ListTruckPositionPage"),
      },
      {
        path: "truckposition/view/:truck_position_id",
        name: "View Truck",
        component: lazyLoad("Report/TruckPosition/ViewTruckPositionPage"),
      },
      {
        path: "viewpartner",
        name: "Report Partner",
        component: lazyLoad("Report/Partner/MasterPartnerPage"),
      },
      {
        path: "viewpartner/view/:partner_id",
        name: "Report Partner Detail",
        component: lazyLoad("Report/Partner/ViewPartnerPage"),
      },
      {
        path: "vieworder",
        name: "Report Order",
        component: lazyLoad("Report/Order/MasterOrderPage"),
      },
      {
        path: "viewcustomer",
        name: "Report Customer",
        component: lazyLoad("Report/Customer/MasterCustomerPage"),
      },
      // {
      //   path: "viewcustomer/view/:customer_id",
      //   name: "Report Customer Detail",
      //   component: lazyLoad("Report/Customer/ViewCustomerPage"),
      // },
      {
        path: "viewfleet",
        name: "Report Fleet",
        component: lazyLoad("Report/Fleet/MasterFleetPage"),
      },
      {
        path: "viewfleet/view/:fleet_id",
        name: "Report Fleet Detail",
        component: lazyLoad("Report/Fleet/ViewFleetPage"),
      },
      {
        path: "viewfreight",
        name: "Report Freight",
        component: lazyLoad("Report/Freight/MasterFreightPage"),
      },
      {
        path: "viewfreight/view/:freight_id",
        name: "Report Freight Detail",
        component: lazyLoad("Report/Freight/ViewFreightPage"),
      },
      {
        path: "viewprofitloss",
        name: "Report Profit & Loss",
        component: lazyLoad("Report/Invoice/ViewProfitLossPage"),
      },
      // {
      //   path: "commandcenter",
      //   name: "Command Center",
      //   component: lazyLoad("Maps/CommandCenterPage"),
      // },
      {
        path: "commandcenter",
        name: "Command Center",
        component: lazyLoad("Maps/CommandCenterLivePage"),
      },
      {
        path: "faq",
        name: "Faq",
        component: lazyLoad("Faq/FaqPage"),
      },
      {
        path: "faq/:faq_detail_id",
        name: "FaqDetail",
        component: lazyLoad("Faq/FaqDetailPage"),
      },
      {
        path: "lastpositionmaps",
        name: "Last Position Maps",
        component: lazyLoad("Report/LastPositionMaps/LastPositionMapPage"),
      },
      {
        path: "mydashboard",
        name: "myDashboard",
        component: lazyLoad("MyDashboard/MyDashboardIndexDummy"),
      },
      {
        path: "loading_list/add/:company_order_detail_id/:company_order_id",
        name: "Add Loading List",
        component: lazyLoad("Order/LoadingList/AddLoadingList"),
      },
      {
        path: "loading_list/edit/:loading_list_id/:company_order_id",
        name: "Edit Loading List",
        component: lazyLoad("Order/LoadingList/EditLoadingList"),
      },
      {
        path: "purchase_order/add/:company_order_id/:company_order_detail_id/:partner_id",
        name: "Add Purchase Order",
        component: lazyLoad("Order/AddPurchaseOrderPage"),
      },
      {
        path: "purchase_order/edit/:purchase_order_id",
        name: "Edit Purchase Order",
        component: lazyLoad("Order/EditPurchaseOrderPage"),
      },
      {
        path: "generalsetting",
        name: "General Setting",
        component: lazyLoad("Setting/MasterSettingPage"),
      },
      {
        path: "invoice",
        name: "Customer Invoice",
        component: lazyLoad("Invoice/Invoice/MasterInvoice"),
      },
      {
        path: "invoice/add",
        name: "Add Customer Invoice",
        component: lazyLoad("Invoice/Invoice/AddInvoicePage"),
      },
      {
        path: "/invoice/add/:order_id",
        name: "Add Customer Invoice Order",
        component: lazyLoad("Invoice/Invoice/AddInvoicePage"),
      },
      {
        path: "invoice/edit/:invoice_id",
        name: "Edit Customer Invoice",
        component: lazyLoad("Invoice/Invoice/EditInvoicePage"),
      },
      {
        path: "invoicevendor",
        name: "Vendor Invoice",
        component: lazyLoad("Invoice/Vendor/MasterInvoiceVendor"),
      },
      {
        path: "invoicevendor/add",
        name: "Add Vendor Invoice",
        component: lazyLoad("Invoice/Vendor/AddInvoiceVendorPage"),
      },
      {
        path: "invoicevendor/edit/:invoice_vendor_id",
        name: "Edit Vendor Invoice",
        component: lazyLoad("Invoice/Vendor/EditInvoiceVendorPage"),
      },
      {
        path: "coa",
        name: "COA",
        component: lazyLoad("Master/Coa/MasterCoa"),
      },
      {
        path: "coa/add",
        name: "Add COA",
        component: lazyLoad("Master/Coa/AddCoaPage"),
      },
      {
        path: "coa/upload",
        name: "upload COA",
        component: lazyLoad("Master/Coa/UploadCoaPage"),
      },
      {
        path: "coa/edit/:coa_id",
        name: "Edit COA",
        component: lazyLoad("Master/Coa/EditCoaPage"),
      },
      {
        path: "driver",
        name: "Driver",
        component: lazyLoad("Master/Driver/MasterDriverPage"),
      },
      {
        path: "driver/add",
        name: "Add Driver",
        component: lazyLoad("Master/Driver/AddDriverPage"),
      },
      {
        path: "driver/edit/:driver_id",
        name: "Edit Driver",
        component: lazyLoad("Master/Driver/EditDriverPage"),
      },
      {
        path: "order/trucking/add/:order_id",
        name: "Add Order Trucking",
        component: lazyLoad("Order/Trucking/AddOrderTrucking"),
      },
      {
        path: "order/trucking/edit/:trucking_id",
        name: "Edit Order Trucking",
        component: lazyLoad("Order/Trucking/EditOrderTrucking"),
      },
      {
        path: "freight/upload",
        name: "Upload Freight",
        component: lazyLoad("Master/Freight/UploadFreightPage"),
      },
      {
        path: "customer/upload",
        name: "Upload Customer",
        component: lazyLoad("Master/Customer/UploadCustomerPage"),
      },
      {
        path: "partner/upload",
        name: "Upload Partner",
        component: lazyLoad("Master/Partner/UploadPartnerPage"),
      },
      {
        path: "partner/upload_fleet_partner",
        name: "Upload Fleet Partner",
        component: lazyLoad("Master/Partner/UploadFleetPartnerPage"),
      },
      {
        path: "customer/location/upload",
        name: "Upload Customer Location",
        component: lazyLoad("Master/Customer/UploadCustomerLocationPage"),
      },
      {
        path: "marketplace",
        name: "Job List",
        component: lazyLoad("Marketplace/MarketplacePage"),
      },
      {
        path: "marketplace/jobrequest",
        name: "Job Request",
        component: lazyLoad("Marketplace/JobRequestPage"),
      },
      {
        path: "marketplace/jobrequest/new",
        name: "New Job Request",
        component: lazyLoad("Marketplace/JobRequestFormPage"),
      },
    ],
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export default router;
